import {
  mixed,
  object,
} from 'yup';

export const upsertWatchlistEntryValidationSchema = object().shape({
  countryId: mixed().required(),
});


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/validation-schemas/upsertWatchlistEntryValidationSchema.js